
// export const setAuthToken = (token) => {
//    localStorage.setItem('token', token);
// };

// export const setAuthData = ( userDetails) => {
//     localStorage.setItem('userDetails', JSON.stringify(userDetails));
//  };
 
//  export const getToken = () => {
//     return localStorage.getItem('token');
//  };
  
//  export const getUserDetails = () => {
//     const userDetailsString = localStorage.getItem('userDetails');
//     return userDetailsString ? JSON.parse(userDetailsString) : null;
//  };
 
//  export const clearAuthData = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('userDetails');
//     localStorage.removeItem('profileImage');
//  };
 

export const setAuthToken = (token, storageType = "local") => {
   if (storageType === "local") {
     localStorage.setItem("token", token);
   } else {
     sessionStorage.setItem("token", token);
   }
 };

 export const setAuthData = (userDetails, storageType = "local") => {
   const storage = storageType === "local" ? localStorage : sessionStorage;
   storage.setItem("userDetails", JSON.stringify(userDetails));
 };
 
 export const getToken = () => {
   return localStorage.getItem("token") || sessionStorage.getItem("token");
 };
 
 export const getUserDetails = () => {
   const userDetailsString =
     localStorage.getItem("userDetails") || sessionStorage.getItem("userDetails");
   return userDetailsString ? JSON.parse(userDetailsString) : null;
 };

 export const clearAuthData = () => {
   localStorage.removeItem("token");
   localStorage.removeItem("userDetails");
   localStorage.removeItem("profileImage");

   sessionStorage.removeItem("token");
   sessionStorage.removeItem("userDetails");
   sessionStorage.removeItem("profileImage");

 };
